<template>
  <div class="lv-info-ques-option-list">
    <div
      v-for="(option, optionIndex) in list"
      :key="optionIndex"
      class="lv-info-ques-option-list__wrap"
    >
      <LvFlexBox>
        <LvText bold>{{ `${option.title}` }}</LvText>
        <LvFlexBox v-if="!option.hasSubOption">
          <LvText>{{ $_getSettingText(option) }}</LvText>
        </LvFlexBox>
      </LvFlexBox>
      <div
        v-if="option.hasSubOption && option.subOptionList && option.subOptionList.length"
        class="lv-info-ques-option-list_subOption-wrap"
      >
        <LvFlexBox
          v-for="(subOption, subOptionIndex) in option.subOptionList"
          :key="subOptionIndex"
          class="mb-8"
        >
          <LvFlexBox>
            <LvText bold>{{ `${subOption.title}` }}</LvText>
            <LvText>{{ $_getSettingText(subOption) }}</LvText>
          </LvFlexBox>
        </LvFlexBox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    }
  },
  methods: {
    $_getSettingText(option) {
      const {risk, score, requiredRemark} = option;
      let settingText = '';
      if (risk) settingText += `：${this.$t(risk)} `;
      if (score !== undefined && score !== null) settingText += settingText ? `/ ${score} ` : `：${score}`;
      if (requiredRemark) settingText += settingText ? `/ ${this.$t('選答時要求必填備註')}` : `：${this.$t('選答時要求必填備註')}`;
      return settingText;
    }
  }
}
</script>